import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { APIService } from './../api.service';
import { CommonService } from './../services/common.service';

@Component({
    selector: 'app-daily-stock',
    templateUrl: './daily-stock.component.html',
    styleUrls: ['./daily-stock.component.scss']
})
export class DailyStockComponent implements OnInit {

    constructor(private apiService: APIService, public commonService: CommonService) { }

    period: any = 1;
    months: any = [];
    curDate: any = new Date();
    year: any;
    month: any;
    agencyTbl: any;
    enableDailyItemizedINV: any;
    jarvisData: any = [];
    isAdmin: any = false;
    isCloseShow: any = false;
    ERPAgnID: any;
 

     // var d = new Date();

    view = {
        month: this.curDate.getMonth() + 1,
        year: this.curDate.getFullYear()
    }

    dailyStockList: any = [];
    yearList: any = [];

  //  dataSource = new MatTableDataSource();
  //  displayedColumns: string[] = ['date', 'value', 'note'];

    //dailyStockList: any = [{
    //    date: new Date(),
    //    value: '150',
    //    note: 'Test',
    //    agencyStockID: 1
    //},
    //    {
    //        date: new Date(),
    //        value: '170',
    //        note: 'Test1',
    //        agencyStockID: 2
    //    }]

    ngOnInit(): void {
        this.year = this.curDate.getFullYear();
        this.month = this.curDate.getMonth() + 1;
        this.getPeriodData();
        // this.dataSource.data = this.dailyStockList;
        this.getCookieData();
      //  this.getData();
        this.getListData(this.view.month);
    }

    getCookieData() {
        var MTbl = this.apiService.getCookie("M");
        var jarvis = this.apiService.getCookie("Jarvis");
        if (jarvis) {
            this.jarvisData = JSON.parse(jarvis);
        }
        if (MTbl) {
            this.agencyTbl = JSON.parse(MTbl);
            if (this.agencyTbl.length > 0) {
                this.ERPAgnID = this.agencyTbl[0].ERPAgencyID;
                if (this.agencyTbl[0].EnblDailyItemizedInv == false) {
                    this.enableDailyItemizedINV = true;
                }
                else {
                    this.enableDailyItemizedINV = false;
                }
            }        
        }

        if (this.jarvisData[0].UserID == this.agencyTbl[0].AdminUserID) {
            this.isAdmin = true;
        }
        else {
            this.isAdmin = false;
        }
    }

  
    yearChange() {
        debugger
        this.getPeriodData();
        this.getListData(this.view.month);
    }

    getPeriodData() {
        this.yearList = [];

        let monthList = [{ year: 'January', number: 1 }, { year: 'February', number: 2 }, { year: 'March', number: 3 }, { year: 'April', number: 4 }, { year: 'May', number: 5 },
            { year: 'June', number: 6 }, { year: 'July', number: 7 }, { year: 'August', number: 8 }, { year: 'September', number: 9 }, { year: 'October', number: 10 },
            { year: 'November', number: 11 }, { year: 'December', number: 12 }]

        for (let i = 2020; i <= this.year; i++) {
            let tempYear = {
                year: i
            }
            this.yearList.push(tempYear);
        }

        if (this.view.year == this.year) {
            this.months = monthList.slice(0, this.month);
        }
        else {
            this.months = monthList;
        }
       // this.view.month = this.months[this.months.length - 1].number + '';

       // this.months = monthList.slice(0, this.month + 1);
        this.months.reverse();
    }

    changeFilter(obj: any) {
        this.year = this.curDate.getFullYear();
        this.view.year = this.year;

        if (obj == 1) {
            this.period = 1
            this.view.month = this.curDate.getMonth() + 1;
            this.getListData(this.view.month);
        }
        else if (obj == 2) {
            this.period = 2;
            this.view.month = this.curDate.getMonth();
            if (this.view.month == 0) {
                this.view.month = 12;
                this.year = this.curDate.getFullYear() - 1;
                this.view.year = this.year;
            }
            this.getListData(this.view.month);

        }
        else if (obj == 3) {
            this.period = 3;
            this.view.month = this.curDate.getMonth() + 1;
            if (this.view.month == 0) {
                this.view.month = 12;
                this.year = this.curDate.getFullYear() - 1;
                this.view.year = this.year;
            }
            this.getListData(this.view.month);
        }
    }
    

    //getData
    //getData() {
    //    this.dailyStockList.forEach(function (item: any) {
    //        item.isEdit = false;
    //    });
    //    console.log(this.dailyStockList);
    //}

    //getCopyData
    getCopyNote() {
        this.dailyStockList.forEach(function (item: any) {
            item.copyNote = '';
        })
    }

    //getData()
    getListData(months: any) {
        months = this.view.month;
        var tempData = [{
            'month': months,
            'year': this.view.year,
            'ERPAgnID': this.ERPAgnID
            //'month': 1,
            //'year': 2021,  
        }]

        let myParams = [{
            myUserID: this.jarvisData[0].UserID,
            myToken: this.jarvisData[0].WebToken,
            forAgencyID: this.jarvisData[0].AgencyIDs,
            myAgencyIDs: this.jarvisData[0].AgencyIDs,
            myLastSyncDT: null,
            isWeb: true,
            actionType: 'get',
            moduleID: 3,
            data: JSON.stringify(tempData),
            ForERPAgencyID: this.ERPAgnID
        }];
        this.apiService.getData(myParams, this.successResp.bind(this), this.failureResp.bind(this));
    }


    //successResp - success  get handler
    successResp(res: any) {
        if (res.error) {
        }
        else {
            if (res) {
                var reponseData = JSON.parse(res.updatePackage);
                if (reponseData.Table) {                  
                    var dataRes = reponseData.Table1;
                    if (dataRes.length > 0) {
                        let currDate = new Date().customFormat("#YYYY#-#MMM#-#DD#");
                        dataRes = $.grep(dataRes, (o: any) => { 
                            return new Date(new Date(o.EffectiveDate).customFormat("#YYYY#-#MMM#-#DD#")) < new Date(currDate)
                        });
                        this.dailyStockList = dataRes;
                        this.getCopyNote();
                    }
                    else {
                        this.dailyStockList = [];
                    }                 
                }
            }
        }
    }

    //editStock
    editStock(index: any) {
        this.dailyStockList[index].Edit = true;
        this.dailyStockList[index].Note = this.dailyStockList[index].Note;
        this.dailyStockList[index].copyNote = '';
        if (this.dailyStockList[index].Edit = true) {
            this.isCloseShow = true;
        }
    }

    //cancelStock
    cancelStock(index: any) {
        this.dailyStockList[index].Edit = false;
    }

    //saveStock
    saveStock(index: any, obj: any) {

        //Validation
        if (obj.StockValue == "" && obj.StockValue == undefined) {
            alert('Please enter value.');
            return;
        }

        else if (obj.copyNote == "") {
            alert('Please enter note.');
            return;
        }
        else {
            var tempData = [{
                'date': obj.EffectiveDate,
                'value': obj.StockValue,
                'changeNote': obj.copyNote,
                'agencyStockID': obj.AgencyStockID,
                'displayName': this.jarvisData[0].UserName
            }]

            let myParams = [{
                myUserID: this.jarvisData[0].UserID,
                myToken: this.jarvisData[0].WebToken,
                forAgencyID: this.jarvisData[0].AgencyIDs,
                myAgencyIDs: this.jarvisData[0].AgencyIDs,
                myLastSyncDT: null,
                isWeb: true,
                actionType: 'set',
                moduleID: 3,
                data: JSON.stringify(tempData),
                 ForERPAgencyID: this.ERPAgnID
            }];

            this.apiService.sendChange(myParams, this.successEntry.bind(this), this.failureResp.bind(this));
            this.dailyStockList[index].Edit = false;
           // this.getData();
           // this.getListData(this.view.month);
        }
    }

    //successVchrEntry - success voucher entry handler
    successEntry(res: any) {
        if (res.error) {
        }
        else {         
            this.getListData(this.view.month);
        }     
    }

    //failureResp - failure handler
    failureResp(res: any) {
        if (res.error) {
        }
        else {
            alert(res.message);
        }
    }

    //numberOnly
    numberOnly(event: any): boolean {
        return this.commonService.numberOnly(event);
    }
}
